import { Font } from "components/shopFeatures/wizard/constants"
import { ReactNode } from "react"
import styled from "styled-components"

const StyledListCirclePicture = styled.ul`
  padding: 0;
  margin: 0;
  list-style-position: outside;

  ${(p) => p.theme.breakpoints.down("sm")} {
    padding: 0;
  }
`

const StyledListItemPicture = styled.li`
  font-family: ${Font.OENaPro};
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0em;
  list-style-type: none;
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  :last-child {
    margin-bottom: 8px;
  }
`

const StyledImg = styled.img`
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
`

const StyledContent = styled.span`
  display: block;
  padding-right: 10px;
`

export type ListCirclePictureProps = {
  children: ReactNode
}

export type ListItemCirlcePictureProps = {
  content: string
  $key: string
  image: string
}

export const ListCirclePicture = ({ children }: ListCirclePictureProps) => (
  <StyledListCirclePicture>{children}</StyledListCirclePicture>
)

export const ListItemCirlcePicture = ({
  content,
  $key,
  image,
}: ListItemCirlcePictureProps) => {
  return (
    <StyledListItemPicture key={$key}>
      <StyledImg src={image} alt={`Thumbnail image of ${content}`} />
      <StyledContent>{content}</StyledContent>
    </StyledListItemPicture>
  )
}
